import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2495d8c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "values" }

import {AutoModFloodOptions} from "@/types/GuildSettings";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoModFloodOptions',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const positiveIntegerRules = [
  (number: number) => (number > 0 && !(number % 1)) || i18n.global.t('GuildModeration.errors.invPosNumber')
]


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_v_text_field, {
          modelValue: props.modelValue.messages,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.modelValue.messages) = $event)),
          class: "value",
          color: "primary",
          rules: positiveIntegerRules,
          label: _ctx.$t('GuildModeration.subtitles.maxMessages'),
          onSubmit: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', props.modelValue)))
        }, null, 8, ["modelValue", "label"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_v_text_field, {
          modelValue: props.modelValue.symbols,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.modelValue.symbols) = $event)),
          class: "value",
          color: "primary",
          rules: positiveIntegerRules,
          label: _ctx.$t('GuildModeration.subtitles.maxSymbols'),
          onSubmit: _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', props.modelValue)))
        }, null, 8, ["modelValue", "label"])
      ])
    ])
  ]))
}
}

})